import { html, css } from 'lit-element';
import { BaseElement } from './BaseElement';
import { faMagic, faUserMd } from '@fortawesome/free-solid-svg-icons';
import { API, EVENT_TYPE_LOGIN_STATUS } from '../API';
import { newGUID } from '../GUID';
import { DIALOG_TYPE_ERROR, DIALOG_TYPE_INFO } from './ModalDialog';
import { Account } from '../Account';

const _api = Symbol();
const _account = Symbol();
const _statusHandler = Symbol();

class Admin extends BaseElement {
	constructor() {
		super();

		this.library.add(faMagic, faUserMd);

		this[_statusHandler] = () => this.requestUpdate();
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				:host {

				}
				.centered {
					display: flex;
					justify-content: center;
				}
			`
		];
	}
	get api() {
		return this[_api];
	}
	set api(v) {
		if(v !== null && !(v instanceof API))
			throw new TypeError('api must be an instance of API.');
		this[_api] = v;
	}
	get account() {
		return this[_account];
	}
	set account(v) {
		if(v !== null && !(v instanceof Account))
			throw new TypeError('account must be an instance of Account.');
		this[_account] = v;
	}
	connectedCallback() {
		super.connectedCallback();

		this.emit('get-api', { callback: api => this.api = api });
		this.emit('get-account', { callback: account => this.account = account });
		this.api.on(EVENT_TYPE_LOGIN_STATUS, this[_statusHandler]);
		
	}
	disconnectedCallback() {
		super.disconnectedCallback();

		this.api.off(EVENT_TYPE_LOGIN_STATUS, this[_statusHandler]);
		this.api = null;
	}
	async handleSubmit(e) {
		const id = newGUID();
		try {
			e.preventDefault();
			this.emit('show-busy', id);

			const detail = Object.fromEntries(new FormData(e.target));
			e.target.reset();
			const { doctorId } = detail;
			await this.api.refresh(doctorId || null);
			this.emit('show-dialog', {
				title: 'Temporary Doctor Association',
				message: this.account.appServerDoctorId ?
					`You are currently associated with AppServer Doctor Id ${this.account.appServerDoctorId}` :
					'You are currently not associated with an AppServer Doctor Id.'
				,
				type: DIALOG_TYPE_INFO
			});
			this.emit('hide-busy', id);
		}
		catch(err) {
			this.emit('hide-busy', id);
			console.error(err);
			this.emit('show-dialog', {
				title: 'AppServer Doctor ID Error',
				message: err.message,
				type: DIALOG_TYPE_ERROR
			});
		}
	}
	updated() {
		super.updated();
		const input = this.shadowRoot.querySelector('input[name="doctorId"]');
		if(input)
			input.value = this.account.appServerDoctorId || '';
	}
	render() {
		return this.api.isAdmin ?
			html`
				<h4>Administration</h4>
				<p>
					You may temporarily associate your account with an AppServer Doctor ID.  Please note that restarting your browser or refreshing the page will remove this temporary assignment.
				</p>
				<div class="centered">
					<form @submit="${e => this.handleSubmit(e)}">
						<input type="text" placeholder="Doctor ID" name="doctorId"/>
						<button type="submit"">
							<i class="icon fas fa-user-md"></i>
							Associate
						</button>
					</form>
				</div>
			` :
			html`
				<div>
					<h4>Admin is unavailable.</h4>
					<p>You are not an admin.</p>
				</div>
			`;
	}
}

customElements.define('pp-admin', Admin);